/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { activateOnPage } from "../../utils";

// Widget Builder javascript functions

namespace('Slzr.Page', function(exports) {
  const $ = Slzr.jQuery;

  exports.WidgetBuilder = class WidgetBuilder {
    constructor() {
      this.updateVisibilityForTemplate = this.updateVisibilityForTemplate.bind(this);
      this.updateVisibilityForType = this.updateVisibilityForType.bind(this);
      this.processHideIf = this.processHideIf.bind(this);
      this.buildCode = this.buildCode.bind(this);
      this.openPreview = this.openPreview.bind(this);
      this.buildURL = this.buildURL.bind(this);
      this.form = document.querySelector('[data-form="widget-builder"]');
      this.template = this.form.querySelector('#template');
      this.widgetType = this.form.querySelector('#widget_type');

      this.form.querySelector('[data-action="build-widget-code"]').addEventListener('click', () => this.buildCode());
      this.form.querySelector('[data-action="preview-widget"]').addEventListener('click', () => this.openPreview());

      // Update initial state
      this.updateVisibilityForType();
      this.updateVisibilityForTemplate();

      this.form.querySelectorAll('[data-hide-if]').forEach(el => {
        const {
          hideIf
        } = el.dataset;
        const hideIfCondParts = hideIf.split(':');
        const targetNameOrId = hideIfCondParts[0];
        const targetValue = hideIfCondParts[1];

        const obj = el.closest('form').querySelector(`[name="${  targetNameOrId  }"], #${  targetNameOrId}`);

        if (obj) {
          this.processHideIf(obj, targetValue, el);
          return obj.addEventListener('change', () => this.processHideIf(obj, targetValue, el));
        }
      });

      if (this.template) {
        this.template.addEventListener('change', () => this.updateVisibilityForTemplate());
      }
      if (this.widgetType) {
        this.widgetType.addEventListener('change', () => this.updateVisibilityForType());
      }
    }

    updateVisibilityForTemplate() {
      // Default to no template set if it's undefined or null (i.e. selector isn't on the form)
      const templateValue = this.template ? this.template.value : '';

      const wrapperElem1 = this.form.querySelector("[data-default-template]");
      const wrapperElem1IsVisible = templateValue === '';
      this.setVisibility(wrapperElem1, wrapperElem1IsVisible);
      this.form.querySelectorAll("[data-default-only]").forEach(el => {
        return el.disabled = templateValue !== '';
      });
      // support any old customized templates where style was defined in the template
      if (wrapperElem1IsVisible && (wrapperElem1.style.display === 'none')) {
        wrapperElem1.style.removeProperty('display');
      }

      const wrapperElem2 = this.form.querySelector("[data-not-default-template]");
      const wrapperElem2IsVisible = templateValue !== '';
      this.setVisibility(wrapperElem2, wrapperElem2IsVisible);
      this.form.querySelectorAll("[data-not-default]").forEach(el => {
        return el.disabled = templateValue === '';
      });
      // support any old customized templates where style was defined in the template
      if (wrapperElem2IsVisible && (wrapperElem2.style.display === 'none')) {
        return wrapperElem2.style.removeProperty('display');
      }
    }

    updateVisibilityForType() {
      this.form.querySelectorAll('[data-widget-types]').forEach(el => {
        return this.setVisibility(el, false, true);
      });

      if (this.widgetType) {
        return this.form.querySelectorAll(`[data-widget-types~='${this.widgetType.value}']`).forEach(el => {
          return this.setVisibility(el, true, true);
        });
      }
    }

    processHideIf(inputEl, value, controlledEl) {
      const shouldHide = this.shouldHideVisibility(inputEl, value);
      return this.setVisibility(controlledEl, !shouldHide, true);
    }

    shouldHideVisibility(inputEl, value) {
      if (inputEl.type === 'checkbox') {
        const targetValueBool = (value === 'checked') || !(value === 'unchecked');
        return inputEl.checked === targetValueBool;
      } 
        return inputEl.value === value;
      
    }

    setVisibility(el, isVisible, disableInputsFromVisible) {
      if (disableInputsFromVisible == null) { disableInputsFromVisible = false; }
      el.classList.toggle("em-hidden", !isVisible);
      if (disableInputsFromVisible) {
        return el.querySelectorAll('input, select, textarea').forEach(input => {
          return input.disabled = !isVisible;
        });
      }
    }

    buildCode() {
      const the_id = Math.floor(Math.random() * 100000000);
      const the_url = this.buildURL({container: `localist-widget-${the_id}`});

      const embedContainer = this.form.querySelector('#x-widget-javascript');
      if (embedContainer.classList.contains('em-hidden')) {
          this.setVisibility(embedContainer, true);
      } else {
        // support any old customized templates where style was defined in the template
        if (embedContainer.style.display === 'none') {
          embedContainer.style.removeProperty('display');
        }
      }


      let js_code = `<div id="localist-widget-${  the_id  }" class="localist-widget"></div><` + `script defer type="text/javascript"\nsrc="${  the_url  }"><` + `/script>`;

      // Append logo
      if (!Slzr.Meta['unbranded-widget']) {
        js_code += '<div id="lclst_widget_footer"><a style="margin-left:auto;margin-right:auto;display:block;width:81px;margin-top:10px;" title="Widget powered by Concept3D Event Calendar Software" href="https://www.localist.com?utm_source=widget&utm_campaign=widget_footer&utm_medium=branded%20link"><img src="//d3e1o4bcbhmj8g.cloudfront.net/assets/platforms/default/about/widget_footer.png" alt="Localist Online Calendar Software" style="vertical-align: middle;" width="81" height="23"></a></div>';
      }

      // TODO: REMOVE JQUERY
      $('#x-widget-javascript-code').val(js_code).focus().select();

      // TODO: REMOVE JQUERY
      return $.post("/static/track_widget_create");
    }

    openPreview() {
      const the_url = this.buildURL({format: 'html'});
      return window.open(the_url, 'widgetPreview');
    }

    buildURL(overrides) {
      if (overrides == null) { overrides = {}; }
      const params = {};
      let opts = {};
      const arrayValues = ['types', 'exclude_types', 'venues', 'exclude_venues', 'groups', 'exclude_groups', 'departments', 'exclude_departments'];

      // TODO: REMOVE JQUERY
      const my_form = $(this.form);

      // Don't like this b/c jQuery assumes a disabled input should not be included in the form values according to docs,
      // as there have been enough use cases where I needed to include disabled inputs in a form...
      // (eg. controlled disabled inputs, there just for UI/presentation purposes)

      // Collect attributes
      _(my_form.serializeArray()).each(function(el) {
        // Handle special array values
        if (_.contains(arrayValues, el.name)) {
          if (!opts[el.name]) { opts[el.name] = []; }
          return opts[el.name].push(el.value);
        } 
          // Don't include placeholders
          // TODO: REMOVE JQUERY
          const in_el = $(`[name="${  el.name  }"]`, my_form);
          if (in_el.attr('placeholder') === el.value) {
            return opts[el.name] = '';
          } 
            return opts[el.name] = el.value;
          
        
      });

      opts = $.extend(opts, overrides);

      // Clean up other inputs and add to params
      switch (opts.event_source) {
        case 'schools': case '': case undefined:
          if ((opts.campuses != null) && !opts.campuses.isBlank()) {
            params['campuses'] = opts.campuses;
          } else if ((opts.schools != null) && !opts.schools.isBlank()) {
            params['schools'] = opts.schools;
          }
          break;

        case 'cities':
          if (opts.neighborhoods && !opts.neighborhoods.isBlank()) {
            params['neighborhoods'] = opts.neighborhoods;
          } else if (opts.cities && !opts.cities.isBlank()) {
            params['cities'] = opts.cities;
          }
          break;
      }
      
      // Format array values
      arrayValues.forEach(key => {
        if (opts[key] && opts[key] instanceof Array) {
          params[key] = (_.reject(opts[key], el => (el === 0) || el.isBlank())).join(',');
          if (params[key].isBlank()) { return delete params[key]; }
        } else if ((opts[key] != null) && !opts[key].isBlank()) {
          return params[key] = opts[key].split(/\s*,\s*/).join(',');
        }
      });

      if ((opts.style == null) && (opts.include_styles != null)) {
        opts.style = opts.include_styles === '1' ? '' : 'none';
        delete opts.include_styles;
      }

      // Other values
      params['days'] = (opts.days != null) && !opts.days.isBlank() ? opts.days : 31;
      params['num'] = (opts.num != null) && !opts.num.isBlank() ? opts.num : 50;
      if ((opts.age_requirement != null) && (opts.age_requirement !== '0')) { params['age_limit'] = opts.age_requirement; }
      if (opts.staff_picks === '1') { params['picks'] = 1; }
      if (opts.skip_recurring === '1') { params['skip_recurring'] = 1; }
      if (opts.sponsored === '1') { params['sponsored'] = 1; }
      if (!(opts.tags != null ? opts.tags.isBlank() : undefined)) { params['tags'] = opts.tags.split(/\s*,\s*/).join(','); }
      if (opts.all_instances === '1') { params['all_instances'] = 1; }
      if ((opts.match != null) && !opts.match.isBlank()) { params['match'] = opts.match; }
      if (opts.hidedesc === '1') { params['hidedesc'] = 1; }
      if (opts.hideimage === '1') { params['hideimage'] = 1; }
      if (opts.show_times === '0') { params['show_times'] = 0; }
      if (opts.show_types === '0') { params['show_types'] = 0; }
      if (opts.show_view_all_cta === '0') { params['show_view_all_cta'] = 0; }
      if (opts.target_blank === '1') { params['target_blank'] = 1; }
      if (opts.html_descriptions === '1') { params['html_descriptions'] = 1; }
      if (opts.expand_descriptions === '1') { params['expand_descriptions'] = 1; }
      if (opts.hide_past === '1') { params['hide_past'] = 1; }
      if (opts.experience) { params['experience'] = opts.experience; }
      if (opts.exclude_experience) { params['exclude_experience'] = opts.exclude_experience; }

      // Format
      if (opts.container && !opts.container.isBlank()) { params['container'] = opts.container; }
      if (opts.format === 'html') { params['format'] = 'html'; }
      if (opts.widget_type === 'rss') { params['format'] = 'rss'; }

      // Template and style

      if ((opts.style === 'modern') && (!opts.template || (opts.template === ''))) {
        params['template'] = 'modern';
      } else if ((opts.style === 'card') && (!opts.template || (opts.template === ''))) {
        params['template'] = 'card';
      } else {
        if ((opts.style != null) && !opts.style.isBlank()) { params['style'] = opts.style; }
        if ((opts.template != null) && !opts.template.isBlank()) { params['template'] = opts.template; }
      }

      // Build URL
      let url = opts.widget_type === 'combo' ? Slzr.Meta['base-combo-widget-url'] : Slzr.Meta['base-widget-url'];
      return url += `?${  $.param(params)}`;
    }
  };

  // Activate widget builder
  return activateOnPage('widget-builder', () => {
    return new exports.WidgetBuilder();
  });
});